import { BaseButton, Column, Divider, Padding, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import { C1Text, C2Text, C3Text, C4Text } from "../../../common/components/text/CustomText";
import styled from "styled-components";
import { TitleAndInput } from "../../../common/components/input/TitleAndInput";
import { useEffect, useState } from "react";
import CustomInput from "../../../common/components/input/CustomInput";
import CustomIcon from "../../../common/components/image/CustomIcon";
import CustomModal from "../../../common/components/modal/CustomDetailModal";
import CustomPopup from "../../../common/components/popup/CustomPopup";
import Translate from "../../../common/translate/Translate";
import SecondaryButton from "../../../common/components/button/SecondaryButton";
import PrimaryButton from "../../../common/components/button/PrimaryButton";
import { Theme } from "../../../common/Theme";
import { useDevice } from "../../../common/hooks/useDevice";
import TicketDeviceInfoTable from "../components/TicketDeviceInfoTable";
import TicketService from "../../../service/TicketService";
import StoreService from "../../../service/StoreService";

const WebModalGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    height: 75vh;
`;

const WebModalRightGrid = styled.div`
    display: grid;
    grid-template-rows: ${({ isEditMode }) => (isEditMode === true ? "1.2fr 0.9fr 0.9fr" : "repeat(3, 1fr)")};
    gap: 16px;
    height: 75vh;
`;

// const shopSearchMockValues = [
//     { label: "Ram 8 / LGF0001", value: "Ram 8 / LGF0001" },
//     { label: "Ram 9 / LGF0001", value: "Ram 9 / LGF0001" },
//     { label: "Ram 10 / LGF0001", value: "Ram 10 / LGF0001" },
// ];
const issueTypeValues = [
    { label: "Change Equipment", value: "Change Equipment" },
    { label: "Machine", value: "Machine" },
    { label: "Check symptoms", value: "Check symptoms" },
    { label: "Repair", value: "Repair" },
    { label: "Refund", value: "Refund" },
];
const statusValues = [
    { label: "Registered", value: "Registered" },
    { label: "Carried out", value: "Carried out" },
    { label: "Forward the matter", value: "Forward the matter" },
    { label: "Closed", value: "Closed" },
];
// const deviceSearchMockValues = [
//     { label: "01_WASHER 01", value: "01_WASHER 01" },
//     { label: "01_WASHER 02", value: "01_WASHER 02" },
//     { label: "01_WASHER 03", value: "01_WASHER 03" },
// ];

// deviceType 211 + productType combo → combo / deviceType 212 → dryer / 그 외 → washer
const resolveDeviceType = (deviceType, productType) => {
    if (deviceType === "211" && (productType ?? "").toLowerCase().includes("combo")) return "combo";
    if (deviceType === "212") return "dryer";
    return "washer";
};

export function TicketDetailModal({ isOpen, onClose, dto, isSaveMode = false, onSave }) {
    const service = new TicketService();
    const storeService = new StoreService();

    const [shorSearch, setShorSearch] = useState([]);
    const [devices, setDevices] = useState([]);
    const [deviceSearchResult, setDeviceSearchResult] = useState([]);
    const [rawDeviceList, setRawDeviceList] = useState([]);
    const [ticketNo, setTicketNo] = useState(dto?.ticketNo || "");
    const [shopName, setShopName] = useState(dto?.shopName || "");
    const [shopCode, setShopCode] = useState(dto?.shopCode || "");
    const [storeId, setStoreId] = useState(dto?.storeId || "");
    const [issueType, setIssueType] = useState(dto?.issueType || "");
    const [customerName, setCustomerName] = useState(dto?.customerName || "");
    const [contact, setContact] = useState(dto?.contact || "");
    const [registeredDate, setRegisteredDate] = useState(dto?.registeredDate || "");
    const [detail, setDetail] = useState(dto?.detail || "");
    const [status, setStatus] = useState(dto?.status || "Registered");
    const [recipient, setRecipient] = useState(dto?.recipient || "");
    const [deviceId, setDeviceId] = useState(dto?.deviceId || "");
    const [deviceName, setDeviceName] = useState(dto?.deviceName || "");
    const [device, setDevice] = useState(
        dto?.device || {
            deviceNumber: "-",
            type: "-",
            model: "-",
            deviceId: "-",
        }
    );
    const [memo, setMemo] = useState(
        (dto?.memos || []).map((m) => ({ text: m.content || "", createdAt: m.date || "" }))
    );
    const [images, setImages] = useState(dto?.image || []);

    const [isEditMode, setIsEditMode] = useState(isSaveMode);

    const searchStores = (keyword) => {
        storeService
            .getStoreList({ page: 1, pageSize: 5, shopName: keyword })
            .then((response) => {
                const stores = response?.storeInfo || [];
                const searchList = stores.map((store) => {
                    return { label: store.shopName + " / " + store.shopCode, value: store.storeId };
                });
                setShorSearch(searchList);
            })
            .catch((error) => {
                console.error("Error searching stores:", error);
                setShorSearch([]);
            });
    };

    const handleShopNameChange = (value) => {
        const found = shorSearch.find((item) => item.value === value);
        if (found) {
            // 드롭다운에서 매장 선택
            setShopName(found.label);
            setStoreId(found.value);
            return;
        }
        // 직접 입력: 조회는 Enter / 검색아이콘 클릭으로만 수행
        setShopName(value);
        if (!value) setShorSearch([]);
    };

    // 검색어 입력 후 Enter / 검색아이콘 클릭 시 매장 조회
    const onShopSearch = () => {
        searchStores(shopName);
    };

    useEffect(() => {
        if (storeId === "") return;
        storeService
            .getStoreDevice({ storeId: storeId })
            .then((response) => {
                // 04.01.02.17 응답은 기기 객체의 평면 배열(StoreDeviceDto[])
                const deviceArray = Array.isArray(response) ? response : [];
                const deviceList = deviceArray
                    .map((item) => {
                        if (!item?.deviceId) return null;
                        const productType = item.snapshot?.washerDryer?.ProductType;
                        return {
                            deviceId: item.deviceId,
                            name: item.alias || item.deviceId,
                            type: resolveDeviceType(item.deviceType, productType),
                            model: item.modelNm || "-",
                        };
                    })
                    .filter(Boolean);
                setRawDeviceList(deviceList);
                setDevices(
                    deviceList.map((d) => ({
                        label: d.name,
                        value: d.deviceId,
                    }))
                );
                setDeviceSearchResult([]);

                // 티켓에 연결된 기기(deviceId)를 매장 기기 목록과 매칭해 기기정보 매핑
                const matched = deviceList.find((d) => d.deviceId === deviceId);
                if (matched) {
                    setDeviceName(matched.name);
                    setDevice({
                        deviceNumber: matched.name || matched.deviceId,
                        type: matched.type || "-",
                        model: matched.model || "-",
                        deviceId: matched.deviceId,
                    });
                }
            })
            .catch((error) => {
                console.error("Error fetching store device list:", error);
                setRawDeviceList([]);
                setDevices([]);
                setDeviceSearchResult([]);
            });
    }, [storeId]);

    const handleDeviceChange = (value) => {
        const found = devices.find((item) => item.value === value);
        if (found) {
            setDeviceName(found.label);
            const raw = rawDeviceList.find((d) => d.deviceId === value);
            if (raw) {
                setDeviceId(raw.deviceId);
                setDevice({
                    deviceNumber: raw.name || raw.deviceId,
                    type: raw.type || "-",
                    model: raw.model || "-",
                    deviceId: raw.deviceId,
                });
            }
        } else {
            setDeviceName(value);
            // 검색어를 모두 지우면 아래 선택된 기기 정보도 초기화
            if (!value) {
                setDeviceId("");
                setDevice({ deviceNumber: "-", type: "-", model: "-", deviceId: "-" });
                setDeviceSearchResult([]);
            }
        }
    };

    // 검색어 입력 후 Enter / 검색아이콘 클릭 시 입력값을 포함하는 기기 조회
    const onDeviceSearch = () => {
        const keyword = (deviceName || "").toLowerCase();
        setDeviceSearchResult(devices.filter((d) => (d.label || "").toLowerCase().includes(keyword)));
    };

    useEffect(() => {
        setIsEditMode(isSaveMode);
    }, [isSaveMode]);

    // Confirm Modal
    const [isConfirmPopupOpen, setIsConfirmPopupOpen] = useState(false);

    const handleConfirmClose = () => {
        setIsConfirmPopupOpen(false);
    };

    const handleConfirmOk = () => {
        setIsConfirmPopupOpen(false);

        const memosDtoArray = memo.map((m) => ({ date: m.createdAt || "", content: m.text || "" }));

        if (isSaveMode) {
            const reqDto = {
                request: {
                    storeId: storeId,
                    issueType: issueType,
                    customerName: customerName,
                    contact: contact,
                    detail: detail,
                    status: status,
                    recipient: recipient,
                    deviceId: deviceId,
                    memos: memosDtoArray,
                },
            };
            service
                .saveTicket(reqDto)
                .then(() => {
                    if (onSave) onSave();
                    onClose();
                })
                .catch((err) => {
                    console.error("Error saving ticket:", err);
                });
        } else {
            const reqDto = {
                request: {
                    ticketNo: ticketNo,
                    storeId: storeId,
                    issueType: issueType,
                    customerName: customerName,
                    contact: contact,
                    detail: detail,
                    status: status,
                    recipient: recipient,
                    deviceId: deviceId,
                    memos: memosDtoArray,
                },
            };
            service
                .updateTicket(reqDto)
                .then(() => {
                    setIsEditMode(false);
                    if (onSave) onSave();
                    onClose();
                })
                .catch((err) => {
                    console.error("Error updating ticket:", err);
                });
        }
    };

    // Cancel Modal
    const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);
    const [cancelActionType, setCancelActionType] = useState("button");

    const handleCancelClose = () => {
        setIsCancelPopupOpen(false);
    };

    const handleCancelOk = () => {
        setIsCancelPopupOpen(false);

        if (cancelActionType === "modalClose") {
            onClose();
        } else {
            if (isSaveMode) {
                onClose();
            } else {
                setIsEditMode(false);
            }
        }
        setCancelActionType("button");
    };

    // Delete Modal
    const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);

    const handleDeleteClose = () => {
        setIsDeletePopupOpen(false);
    };

    const handleDeleteOk = () => {
        setIsDeletePopupOpen(false);
        service
            .deleteTicket({ ticketNo: ticketNo })
            .then((res) => {
                if (onSave) onSave();
                onClose();
            })
            .catch((err) => {
                console.error("Error deleting ticket:", err);
            });
    };

    // Image upload handler
    const handleImageUpload = (file) => {
        if (!ticketNo) return;
        const reader = new FileReader();
        reader.onload = (e) => {
            service
                .uploadTicketImage({ ticketNo: ticketNo, content: e.target.result })
                .then((res) => {
                    setImages((prev) => [...prev, { idTicketImage: res.idTicketImage, imageUrl: res.url }]);
                })
                .catch((err) => {
                    console.error("Error uploading image:", err);
                });
        };
        reader.readAsDataURL(file);
    };

    // Image delete handler
    const handleImageDelete = (idTicketImage) => {
        service
            .deleteTicketImage({ idTicketImage: idTicketImage })
            .then((res) => {
                setImages((prev) => prev.filter((img) => img.idTicketImage !== idTicketImage));
            })
            .catch((err) => {
                console.error("Error deleting image:", err);
            });
    };

    const currentDevice = useDevice();

    const leftSide = (
        <SizedBox
            width={"100%"}
            height={"100%"}
            border={"solid 1px #E6E6E9"}
            borderRadius={"16px"}
            alignItem={"flex-start"}
            justifyContent={"flex-start"}
            padding={"22px 0"}
            minHeight={"800px"}
        >
            <Row alignItem={"flex-start"} justifyContent={"space-between"} width={"100%"} padding={"0 20px"}>
                <C2Text fontWeight={"600"}>{Translate("ticket.ticketNo")}</C2Text>
                <C1Text fontWeight={"600"}>{ticketNo}</C1Text>
            </Row>
            <SizedBox height={"20px"} />
            <Divider />
            <Padding padding={"20px"} style={{ width: "100%" }}>
                <C2Text fontWeight={"500"}>{Translate("common.shop")}</C2Text>
                <SizedBox height={"5px"} width={"100%"} />
                <TitleAndInput
                    title={Translate("common.name")}
                    type={"search"}
                    placeholder={Translate("placeholder.shopNameSearch")}
                    dropdownValues={shorSearch}
                    inputValue={shopName}
                    setInputValue={handleShopNameChange}
                    disabled={!isEditMode}
                    hasDot={!isEditMode}
                    isSearchIconLeft={true}
                    onSearch={onShopSearch}
                />
                {!isEditMode && (
                    <>
                        <Divider marginTop={"11px"} thickness={"0px"} />
                        <TitleAndInput
                            title={Translate("common.code")}
                            type={"normal"}
                            placeholder={Translate("placeholder.shopCode")}
                            dropdownValues={shorSearch}
                            inputValue={shopCode}
                            setInputValue={setShopCode}
                            disabled={!isEditMode}
                            hasDot={!isEditMode}
                        />
                    </>
                )}
                <Divider marginTop={isEditMode ? "11px" : "19px"} marginBottom={"16px"} />
                <TitleAndInput
                    title={Translate("ticket.type")}
                    type={"select"}
                    placeholder={Translate("placeholder.ticketType")}
                    dropdownValues={issueTypeValues}
                    inputValue={issueType}
                    setInputValue={setIssueType}
                    disabled={!isEditMode}
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput
                    title={Translate("ticket.customerName")}
                    type={"normal"}
                    placeholder={Translate("placeholder.customerName")}
                    inputValue={customerName}
                    setInputValue={setCustomerName}
                    disabled={!isEditMode}
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput
                    title={Translate("store.contact")}
                    type={"normal"}
                    placeholder={Translate("placeholder.phoneNumber")}
                    inputValue={contact}
                    setInputValue={setContact}
                    disabled={!isEditMode}
                />
                {!isEditMode && (
                    <>
                        <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                        <TitleAndInput
                            title={Translate("common.registeredDate")}
                            type={"normal"}
                            placeholder={""}
                            inputValue={registeredDate}
                            setInputValue={setRegisteredDate}
                            disabled={!isEditMode}
                        />
                    </>
                )}
                <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput
                    title={Translate("common.detail")}
                    type={"textAria"}
                    placeholder={Translate("placeholder.issueDetail")}
                    inputValue={detail}
                    setInputValue={setDetail}
                    disabled={!isEditMode}
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput
                    title={Translate("common.status")}
                    type={"select"}
                    dropdownValues={statusValues}
                    inputValue={status}
                    setInputValue={setStatus}
                    disabled={!isEditMode}
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput
                    title={Translate("ticket.recipient")}
                    type={"normal"}
                    placeholder={Translate("placeholder.recipient")}
                    inputValue={recipient}
                    setInputValue={setRecipient}
                    disabled={!isEditMode}
                />
            </Padding>
        </SizedBox>
    );

    const rightSide = (
        <>
            <WebModalRightGrid isEditMode={isEditMode}>
                <SizedBox
                    width={"100%"}
                    height={"100%"}
                    border={`solid 1px ${Theme.color.gray200}`}
                    borderRadius={"16px"}
                    alignItem={"flex-start"}
                    justifyContent={"flex-start"}
                    padding={"22px 21px"}
                    minHeight={"300px"}
                >
                    <C2Text fontWeight={"600"}>{Translate("common.deviceInfo")}</C2Text>
                    <SizedBox height={"12px"} width={"100%"} />
                    {isEditMode && (
                        <>
                            <CustomInput
                                type={"search"}
                                placeholder={Translate("placeholder.deviceInfoSearch")}
                                inputValue={deviceName}
                                setInputValue={handleDeviceChange}
                                dropdownValues={deviceSearchResult}
                                isSearchIconLeft={true}
                                onSearch={onDeviceSearch}
                            />
                            <SizedBox height={"8px"} width={"100%"} />
                        </>
                    )}
                    <TicketDeviceInfoTable device={device} currentDevice={currentDevice} />
                </SizedBox>
                <SizedBox
                    width={"100%"}
                    height={"100%"}
                    border={`solid 1px ${Theme.color.gray200}`}
                    borderRadius={"16px"}
                    alignItem={"flex-start"}
                    justifyContent={"flex-start"}
                    padding={"22px 21px"}
                    minHeight={"270px"}
                >
                    <Row alignItem={"flex-start"} justifyContent={"space-between"} width={"100%"}>
                        <C2Text fontWeight={"600"}>{Translate("ticket.svcMemo")}</C2Text>
                        {isEditMode && memo.length < 10 && (
                            <BaseButton
                                padding={"0 10px"}
                                border={"none"}
                                onClick={() => {
                                    if (memo.length >= 10) return;
                                    const newItem = {
                                        createdAt: new Date().toISOString().replace("T", " ").substring(0, 19),
                                        text: "",
                                    };
                                    const newMemo = [newItem, ...memo];
                                    setMemo(newMemo);
                                }}
                            >
                                <Row alignItem={"center"} cursor={"pointer"}>
                                    <CustomIcon iconName={"add"} size={"18px"} cursor={"pointer"} />
                                    <SizedBox width={"5px"} />
                                    <C4Text fontWeight={"400"}>{Translate("common.memo")}</C4Text>
                                </Row>
                            </BaseButton>
                        )}
                    </Row>
                    <SizedBox height={"10px"} width={"100%"} />
                    {memo.length <= 0 && (
                        <Column width={"100%"} flex={"1"} justifyContent={"center"} alignItem={"center"}>
                            <CustomIcon iconName={"empty_memo"} size={"28px"} />
                            <SizedBox height={"12px"} />
                            <C3Text fontColor={Theme.color.gray500}>{Translate("ticket.emptySvcMemo")}</C3Text>
                        </Column>
                    )}
                    {memo.length > 0 && (
                        <SizedBox
                            width={"100%"}
                            height={"100%"}
                            overflow={"auto"}
                            alignItem={"flex-start"}
                            justifyContent={"flex-start"}
                        >
                            {memo.map((item, index) => (
                                <Padding padding={"5px 0"} style={{ width: "100%" }}>
                                    <CustomInput
                                        type={"memo"}
                                        placeholder={"empty memo"}
                                        inputValue={item.text}
                                        setInputValue={(v) => {
                                            const newMemo = [...memo];
                                            newMemo[index] = {
                                                ...newMemo[index],
                                                text: v,
                                            };
                                            setMemo(newMemo);
                                        }}
                                        onDelete={() => {
                                            const newMemo = [...memo];
                                            newMemo.splice(index, 1);
                                            setMemo(newMemo);
                                        }}
                                        disabled={!isEditMode}
                                        createdAt={item.createdAt}
                                    />
                                </Padding>
                            ))}
                        </SizedBox>
                    )}
                </SizedBox>
                <SizedBox
                    width={"100%"}
                    height={"100%"}
                    border={`solid 1px ${Theme.color.gray200}`}
                    borderRadius={"16px"}
                    alignItem={"flex-start"}
                    justifyContent={"flex-start"}
                    padding={"22px 21px"}
                    minHeight={"270px"}
                >
                    <Row alignItem={"flex-start"} justifyContent={"space-between"} width={"100%"}>
                        <C2Text fontWeight={"600"}>{Translate("common.image")}</C2Text>
                        {isEditMode && (
                            <BaseButton
                                padding={"0 10px"}
                                border={"none"}
                                onClick={() => {
                                    const input = document.createElement("input");
                                    input.type = "file";
                                    input.accept = "image/*";
                                    input.onchange = (e) => {
                                        if (e.target.files && e.target.files[0]) {
                                            handleImageUpload(e.target.files[0]);
                                        }
                                    };
                                    input.click();
                                }}
                            >
                                <Row alignItem={"center"} cursor={"pointer"}>
                                    <CustomIcon iconName={"add"} size={"18px"} cursor={"pointer"} />
                                    <SizedBox width={"5px"} />
                                    <C4Text fontWeight={"400"}>{Translate("common.addImage")}</C4Text>
                                </Row>
                            </BaseButton>
                        )}
                    </Row>
                    {images.length <= 0 && (
                        <Column width={"100%"} flex={"1"} justifyContent={"center"} alignItem={"center"}>
                            <CustomIcon iconName={"empty_image"} size={"24.5px"} />
                            <SizedBox height={"12px"} />
                            <C3Text fontColor={Theme.color.gray500}>{Translate("common.emptyImage")}</C3Text>
                        </Column>
                    )}
                    {images.length > 0 && (
                        <SizedBox
                            width={"100%"}
                            height={"100%"}
                            overflow={"auto"}
                            alignItem={"flex-start"}
                            justifyContent={"flex-start"}
                        >
                            {images.map((img) => (
                                <Padding key={img.idTicketImage} padding={"5px 0"} style={{ width: "100%" }}>
                                    <Row alignItem={"center"} justifyContent={"space-between"} width={"100%"}>
                                        <img
                                            src={img.imageUrl}
                                            alt="ticket"
                                            style={{ maxWidth: "80%", maxHeight: "100px", objectFit: "contain" }}
                                        />
                                        {isEditMode && (
                                            <BaseButton
                                                padding={"0"}
                                                border={"none"}
                                                onClick={() => handleImageDelete(img.idTicketImage)}
                                            >
                                                <CustomIcon iconName={"delete"} size={"18px"} cursor={"pointer"} />
                                            </BaseButton>
                                        )}
                                    </Row>
                                </Padding>
                            ))}
                        </SizedBox>
                    )}
                </SizedBox>
            </WebModalRightGrid>
        </>
    );

    let body = (
        <WebModalGrid>
            {leftSide}
            {rightSide}
        </WebModalGrid>
    );
    let side = "right";
    if (currentDevice === "mobile" || currentDevice === "tablet") {
        body = (
            <>
                {leftSide}
                <SizedBox height={"20px"} />
                {rightSide}
            </>
        );
        side = "center";
    }

    return (
        <CustomModal
            title={isSaveMode ? Translate("ticket.ticketRegistration") : Translate("ticket.ticketDetail")}
            isOpen={isOpen}
            onClose={
                isEditMode
                    ? () => {
                        setCancelActionType("modalClose");
                        setIsCancelPopupOpen(true);
                    }
                    : onClose
            }
            side={side}
            height={"100%"}
            bottomButtons={
                <Row justifyContent={"space-between"} width={"100%"} padding={"20px"}>
                    {!isSaveMode && (
                        <SecondaryButton
                            onClick={() => {
                                if (!isSaveMode && ticketNo) {
                                    setIsDeletePopupOpen(true);
                                } else {
                                    onClose();
                                }
                            }}
                            width={"60px"}
                            padding={"6.5px 10px"}
                            text={Translate("common.delete")}
                            fontColor={Theme.color.rose500}
                        />
                    )}
                    <Row>
                        <SecondaryButton
                            onClick={() => {
                                if (!isEditMode) {
                                    onClose();
                                } else {
                                    setIsCancelPopupOpen(true);
                                }
                            }}
                            width={"60px"}
                            padding={"6.5px 10px"}
                            text={Translate("common.cancel")}
                        />
                        <SizedBox width={"10px"} />
                        <PrimaryButton
                            onClick={() => {
                                if (!isEditMode) {
                                    setIsEditMode(true);
                                } else {
                                    setIsConfirmPopupOpen(true);
                                }
                            }}
                            width={"60px"}
                            padding={"6.5px 10px"}
                            text={isEditMode ? Translate("common.save") : Translate("common.edit")}
                        />
                    </Row>
                </Row>
            }
        >
            {body}
            <CustomPopup
                isOpen={isConfirmPopupOpen}
                onClose={handleConfirmClose}
                onConfirm={handleConfirmOk}
                message={Translate("popup.registerTicket")}
            />
            <CustomPopup
                isOpen={isCancelPopupOpen}
                onClose={handleCancelClose}
                onConfirm={handleCancelOk}
                message={Translate("popup.cancel")}
            />
            <CustomPopup
                isOpen={isDeletePopupOpen}
                onClose={handleDeleteClose}
                onConfirm={handleDeleteOk}
                message={Translate("popup.deleteTicket")}
            />
        </CustomModal>
    );
}
